<template>
  <AppTableControl
    no-filter
    no-export
    @query-debounced="searchName"
    @search-clicked="fetch"
  ></AppTableControl>
</template>

<script>
import AppTableControl from "@/modules/core/components/shared/filter/AppTableControl";
export default {
  name: "TeacherArchivedPageTableControl",
  components: { AppTableControl },
  beforeDestroy() {
    this.$store.dispatch("changeTeacherArchivedListBaseFilters", {
      all: null,
    });
  },
  methods: {
    fetch() {
      this.$store.dispatch("fetchTeacherArchivedList");
    },
    /**
     * Search
     * @param name
     */
    searchName(name) {
      console.log("Name", name);

      this.$store.dispatch("changeTeacherArchivedListBaseFilters", {
        all: name,
      });

      this.fetch();
    },
  },
};
</script>

<style scoped></style>
